import React from 'react';

interface IRefresh {
  size?: string;
}

const Refresh: React.FC<IRefresh> = props => {
  const { size = 14 } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.79753 13.6427C4.93642 13.6427 3.36003 12.9968 2.06836 11.7052C0.776693 10.4135 0.130859 8.8371 0.130859 6.97599C0.130859 5.11488 0.776693 3.53849 2.06836 2.24683C3.36003 0.955159 4.93642 0.309326 6.79753 0.309326C7.75586 0.309326 8.67253 0.507382 9.54753 0.903493C10.4225 1.29905 11.1725 1.86488 11.7975 2.60099V1.14266C11.7975 0.682422 12.1706 0.309326 12.6309 0.309326C13.0911 0.309326 13.4642 0.682422 13.4642 1.14266V5.14266C13.4642 5.69494 13.0165 6.14266 12.4642 6.14266H8.46419C8.00396 6.14266 7.63086 5.76956 7.63086 5.30933C7.63086 4.84909 8.00396 4.47599 8.46419 4.47599H11.1309C10.6864 3.69822 10.0789 3.0871 9.30836 2.64266C8.53725 2.19822 7.7003 1.97599 6.79753 1.97599C5.40864 1.97599 4.22808 2.4621 3.25586 3.43433C2.28364 4.40655 1.79753 5.5871 1.79753 6.97599C1.79753 8.36488 2.28364 9.54544 3.25586 10.5177C4.22808 11.4899 5.40864 11.976 6.79753 11.976C7.86697 11.976 8.83225 11.6704 9.69336 11.0593C10.3942 10.5619 10.9249 9.93574 11.2853 9.18074C11.4354 8.86642 11.7394 8.64266 12.0877 8.64266C12.6779 8.64266 13.1102 9.20504 12.8677 9.74314C12.4249 10.7253 11.7626 11.5599 10.8809 12.2468C9.68641 13.1774 8.3253 13.6427 6.79753 13.6427Z"
        fill="white"
      />
    </svg>
  );
};

export default Refresh;
